import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField as MuiTextField } from 'redux-form-material-ui';
import hourMask from '../../utils/masks/hourMask';

const ConfFormHourField = ({ name, label, disabled }) => (
  <Field
    disabled={disabled}
    name={name}
    label={label}
    fullWidth
    component={MuiTextField}
    {...hourMask}
  />
);

ConfFormHourField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ConfFormHourField.defaultProps = {
  disabled: false,
};

export default ConfFormHourField;
